import { render } from "./CancelCloseOrder.vue?vue&type=template&id=61054178&scoped=true"
import script from "./CancelCloseOrder.vue?vue&type=script&lang=js"
export * from "./CancelCloseOrder.vue?vue&type=script&lang=js"

import "./CancelCloseOrder.vue?vue&type=style&index=0&id=61054178&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61054178"]])

export default __exports__